import React, { useEffect, useRef } from 'react';

import ProgressHeaderItem from './components/progress-header-item/progress-header-item';

import { useMediaQuery } from '../../shared/hooks/hooks';

import './progress-header.scss';

interface Title {
  className?: string;
  value: string;
}

interface HeaderItems {
  isClickable?: boolean;
  isCompleted?: boolean;
  linkUrl?: string;
  section: string;
  showItem?: boolean;
  title: Array<Title>;
}

interface ProgressHeaderProps {
  activeSection: string;
  className?: string;
  headerItems: Array<HeaderItems>;
  onStepClick?: (number) => void;
  title?: string;
}

export default function ProgressHeader(props: ProgressHeaderProps) {
  const {
    activeSection,
    className = '',
    headerItems,
    onStepClick,
    title
  } = props;
  const containerRef = useRef<HTMLDivElement>(null);
  const selectedRef = useRef<HTMLLIElement>(null);
  const breakpoint = useMediaQuery();

  const activeSectionIdx = headerItems
    .map(item => item.section)
    .indexOf(activeSection);
  const completedSections = headerItems.reduce((obj, item, idx) => {
    obj[item.section] = activeSectionIdx > idx || item.isCompleted;
    return obj;
  }, {});

  useEffect(() => {
    const breadcrumbEl = selectedRef.current;

    if (breadcrumbEl) {
      containerRef.current?.scrollTo({
        behavior: 'smooth',
        left: breadcrumbEl.offsetLeft
      });
    }
  }, [breakpoint, activeSection]);

  return (
    <div
      className={`progress-header ${className}`}
      ref={containerRef}
      styleName="container"
    >
      {title && (
        <div
          className="progress-header__title-container"
          styleName="title-container"
        >
          <div styleName="title">{title}</div>
        </div>
      )}
      <ul className="progress-header__progress-list" styleName="progress-list">
        {headerItems
          .filter(item => item.title)
          .map((item, index) => {
            const { isClickable, linkUrl, section, title } = item;
            const isActive = activeSection === section;
            const isSectionCompleted = completedSections[section];
            return (
              <ProgressHeaderItem
                currentStep={index + 1}
                isActive={isActive}
                isCompleted={isSectionCompleted}
                key={section}
                linkUrl={(isClickable || isSectionCompleted) && linkUrl}
                onStepClick={(isClickable || isSectionCompleted) && onStepClick}
                selectedRef={selectedRef}
                title={title.map((i, idx) => (
                  <div className={i.className} key={idx} styleName="title-text">
                    {i.value}
                  </div>
                ))}
              />
            );
          })}
      </ul>
    </div>
  );
}
